import {
    initialBlogsImageDetailImageState,
    initialBlogsImageDetailPostState,
    BlogsImageDetailImageState,
    BlogsImageDetailPostState,
} from 'mk2/apps/blogs/containers/BlogsImageDetail/BlogsImageDetail.reducers';
import { AppState } from 'mk2/reducers';

export const getBlogsImageDetailPostState = (state: AppState, username: string, postSlug: string): BlogsImageDetailPostState =>
    state.containers.blogs.blogsImageDetails[`${username}/${postSlug}`] || initialBlogsImageDetailPostState;

export const getBlogsImageDetailImageState = (state: AppState, username: string, postSlug: string, imageId: number): BlogsImageDetailImageState =>
getBlogsImageDetailPostState(state, username, postSlug).imageDetails[imageId] || initialBlogsImageDetailImageState;
